/**
 * Created by Rodrigo Quesada on 09/03/17.
 */
import {Headers, RequestOptions, URLSearchParams} from '@angular/http';
import {Model} from '../../../domain/model/common/model.class';
import {Injectable} from '@angular/core';
import {UserImpersonationService} from '../../../domain/model/user/user-impersonation.service';
import {IMPERSONATED_USER_PARAM} from '../../../domain/model/common/service.class';
import ProjectionInformation = Model.ProjectionInformation;
import {IMPERSONATED_USER_REMOTE_PARAM} from '../../ocr/ocr.service';

export class FileLocation {

    private readonly _baseUrl: string;
    private readonly _params: URLSearchParams;
    private readonly _baseOptions = new RequestOptions();

    private readonly jsonBaseOptions = new RequestOptions({
        headers: new Headers({'Content-Type': 'application/json'})
    });

    constructor(private readonly _flcm: FileLocation.InjectedMembers,
                namespace: string,
                path?: string,
                private readonly projectionInfo?: ProjectionInformation,
                basePath?: string) {

        this._baseUrl = `${process.env.BACKEND_BASE_URI}/api/${namespace}`;
        if (basePath !== undefined) this._baseUrl = basePath;
        if (path !== undefined) this._baseUrl = `${this._baseUrl}/${path}`;

        this._params = new URLSearchParams();
        if (this.projectionInfo !== undefined) this._params.set('projection', this.projectionInfo.name);
    }

    httpOptions(extraParams?: URLSearchParams, isJson = false) {
        return (isJson ? this.jsonBaseOptions : this._baseOptions).merge({search: this.urlSearchParams(extraParams)});
    }

    url(extraParams?: URLSearchParams): string {
        return `${this._baseUrl}${this._baseUrl.includes('?') ? '&' : '?'}${this.urlSearchParams(extraParams)}`;
    }

    private urlSearchParams(extraParams?: URLSearchParams): URLSearchParams {
        let localParams = this._params.clone();
        if (extraParams) localParams.appendAll(extraParams);

        const impersonatedUserId = this._flcm.impersonationService.impersonatedUserId;
        if (impersonatedUserId && this._flcm.impersonationService.isImpersonationAllowedOnPage) localParams.append(IMPERSONATED_USER_PARAM, impersonatedUserId);

        const impersonateUserRemoteId = this._flcm.impersonationService.impersonatedUserRemoteId;
        if (impersonateUserRemoteId && this._flcm.impersonationService.isImpersonatingWithRemoteId) localParams.append(IMPERSONATED_USER_REMOTE_PARAM, impersonateUserRemoteId);

        return localParams;
    }
}

// region Injection
export module FileLocation {
    @Injectable()
    export class InjectedMembers {
        constructor(readonly impersonationService: UserImpersonationService) {
        }
    }
}
// endregion

@Injectable()
export class FileLocationFactory {

    constructor(private readonly _flcm: FileLocation.InjectedMembers) {}

    create(namespace: string, path?: string, projectionInfo?: ProjectionInformation, basePath?: string): FileLocation {
        return new FileLocation(this._flcm, namespace, path, projectionInfo, basePath);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/files/service/file-location.class.ts